import { IShiftOccupancyStats, TLanguageKey } from '@localina/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Path } from '../../../../enums';
import { PathUtils } from '../../../../utils';
import { useRestaurantId } from '../../../../utils/RestaurantUtils';
import { formatMinutes, getShiftRange, ITimeRange, toPercent } from '../RestaurantStatsTimeline';
import { RestaurantStatsChart } from './RestaurantStatsChart';

interface IProps {
    stats: IShiftOccupancyStats;
    date: string;
    area: string;
    // The day's range, which positions this shift on the shared time axis.
    range: ITimeRange;
    showAverageLabel?: boolean;
}

const RestaurantStatsAreaTile: React.FC<IProps> = (props) => {
    const { i18n } = useTranslation();
    const navigate = useNavigate();

    const restaurantId = useRestaurantId();

    const shiftRange = getShiftRange(props.stats.shift);
    const left = toPercent(shiftRange.from, props.range);
    const width = toPercent(shiftRange.to, props.range) - left;
    const name = props.stats.shift.name[i18n.language as TLanguageKey];
    const time = `${formatMinutes(shiftRange.from)}–${formatMinutes(shiftRange.to)}`;

    const openReservations = () => {
        const date = props.date;
        const areaId = props.area;
        const shiftId = props.stats.shift.id;
        navigate(PathUtils.generateUrl(Path.RESTAURANT_RESERVATIONS, { restaurantId }, { date, areaId, shiftId }));
    };

    return (
        <div
            className="restaurant-stats__area-tile"
            style={{ left: `${left}%`, width: `${width}%` }}
            title={`${name} · ${time}`}
            onClick={openReservations}
        >
            <div className="restaurant-stats__area-tile__title">
                <span className="restaurant-stats__area-tile__title__name">{name}</span>
                <span className="restaurant-stats__area-tile__title__time">{time}</span>
            </div>
            <div className="restaurant-stats__area-tile__charts">
                <RestaurantStatsChart
                    stats={props.stats.stats}
                    range={shiftRange}
                    showAverageLabel={props.showAverageLabel}
                />
            </div>
        </div>
    );
};
export default RestaurantStatsAreaTile;
